import { VALIDATION_MESSAGES } from '@zorro/common-utils';
import jexl from 'jexl';
import * as yup from 'yup';

const isJexlValid = (value: string | undefined) => {
  if (!value) return true;
  try {
    jexl.compile(value);
    return true;
  } catch {
    return false;
  }
};

export const getFormSchema = (
  hasWageType: boolean,
  hasEmploymentType: boolean
) =>
  yup.object({
    eligibilityLogic: yup
      .string()
      .required(VALIDATION_MESSAGES.eligibilityLogicRequired)
      .test('jexl', 'Invalid expression syntax', isJexlValid),
    fullTimeEligibilityLogic: hasEmploymentType
      ? yup
          .string()
          .required(VALIDATION_MESSAGES.fullTimeEligibilityLogicRequired)
          .test('jexl', 'Invalid expression syntax', isJexlValid)
      : yup.string().test('jexl', 'Invalid expression syntax', isJexlValid),
    partTimeEligibilityLogic: hasEmploymentType
      ? yup
          .string()
          .required(VALIDATION_MESSAGES.partTimeEligibilityLogicRequired)
          .test('jexl', 'Invalid expression syntax', isJexlValid)
      : yup.string().test('jexl', 'Invalid expression syntax', isJexlValid),
    salaryEligibilityLogic: hasWageType
      ? yup
          .string()
          .required(VALIDATION_MESSAGES.salaryEligibilityLogicRequired)
          .test('jexl', 'Invalid expression syntax', isJexlValid)
      : yup.string().test('jexl', 'Invalid expression syntax', isJexlValid),
    hourlyEligibilityLogic: hasWageType
      ? yup
          .string()
          .required(VALIDATION_MESSAGES.hourlyEligibilityLogicRequired)
          .test('jexl', 'Invalid expression syntax', isJexlValid)
      : yup.string().test('jexl', 'Invalid expression syntax', isJexlValid),
    customClassCategories: yup
      .array()
      .of(
        yup.object({
          name: yup.string().required(),
          value: yup
            .string()
            .required(VALIDATION_MESSAGES.customClassCategoryLogicRequired)
            .test('jexl', 'Invalid expression syntax', isJexlValid),
        })
      )
      .default([]),
  });

export type FinchEligibilityFormFields = yup.InferType<
  ReturnType<typeof getFormSchema>
>;
